import React from 'react';
import {StaticRouter, Route} from 'react-router-dom';
import IndexLoader from './Common/Loaders/indexLoader';
import dashBoardSkeletonLoader from './Common/Loaders/dashboardLoader';
import documentLoader from './Common/Loaders/documentsLoader';
//import UserSettingsLoader from './Common/Loaders/userSettingsLoader';

import styled, {ThemeProvider} from 'styled-components';
import {getTheme} from '@ey/styled-theme';
//import Nav from './Common/Nav/Nav';
import ServerNav from './Common/Nav/ServerNav';

const StyledAppContainer = styled.div`
	.react-loading-skeleton {
		background: linear-gradient(119deg, var(--neutrals-bg-gradient1) 10%, var(--neutrals-bg-gradient2) 99%);
		background-size: 200px 100%;
		display: inline-block;
		line-height: 1;
		width: 100%;
		background-repeat: no-repeat;
		border-radius: 4px;
		animation: 1.2s ease-in-out 0s infinite normal none running animation-16jpnkj;
	}
`;

const LoaderContainer = (props) => {
	const context = {};
	return (
		<ThemeProvider theme={getTheme()}>
			<StyledAppContainer className={props.className}>
				<StaticRouter location={props.path} context={context}>
					{props.showNav ? <ServerNav /> : null}
					<Route path="/" component={dashBoardSkeletonLoader} exact />
					<Route path="/tasks/:categoryId?/:subcategoryId?/:taskId?" component={IndexLoader} exact />
					<Route path="/dashboard" component={dashBoardSkeletonLoader} exact />
					<Route path="/documents/:documentId?" component={documentLoader} exact />
					{/* <Route path="/usersettings" component={UserSettingsLoader} exact /> */}
				</StaticRouter>
			</StyledAppContainer>
		</ThemeProvider>
	);
};

export default LoaderContainer;
